<tlc-churn-flow-step-template [currentStep]="3" [reasonInfoboxMessage]="infoboxMessage()">
  <div class="left">
    <tlc-churn-flow-reason-template
      [heading]="'tlc.churn_flow.steps.unhelpful_support.heading' | translate"
      [subheading]="'tlc.churn_flow.steps.unhelpful_support.subheading' | translate"
      (stayWithTellent)="stayWithTellent()"
      (stillWantToCancel)="stillWantToCancel()"
    >
      <div class="solutions-container">
        <tlc-churn-flow-solution-card
          [iconVariant]="contactSpecialist.iconVariant"
          [title]="contactSpecialist.title"
          [subtitle]="contactSpecialist.subtitle"
          [incentives]="contactSpecialist.incentives"
        >
          <div class="actions" (click)="contactSpecialistAction()">
            <rt-button variant="tertiary">
              <rt-icon name="open-in-new" />
              <span>{{ contactSpecialist.ctaText }}</span>
            </rt-button>
          </div>
        </tlc-churn-flow-solution-card>

        <tlc-churn-flow-solution-card
          [iconVariant]="joinTrainingSession.iconVariant"
          [title]="joinTrainingSession.title"
          [subtitle]="joinTrainingSession.subtitle"
          [incentives]="joinTrainingSession.incentives"
        >
          <div class="actions">
            <a
              rt-button
              variant="tertiary"
              [href]="getTrainingScheduleLink()"
              target="_blank"
              (click)="trackAlternativeEvent('join_training')"
            >
              <rt-icon name="open-in-new" />
              <span>{{ joinTrainingSession.ctaText }}</span>
            </a>
          </div>
        </tlc-churn-flow-solution-card>

        <tlc-churn-flow-solution-card
          [iconVariant]="exploreQuickStart.iconVariant"
          [title]="exploreQuickStart.title"
          [subtitle]="exploreQuickStart.subtitle"
          [incentives]="exploreQuickStart.incentives"
        >
          <div class="actions">
            <a
              rt-button
              variant="tertiary"
              href="https://support.recruitee.com/collections/1419259"
              target="_blank"
              (click)="trackAlternativeEvent('open_help_center')"
            >
              <rt-icon name="open-in-new" />
              <span>{{ exploreQuickStart.ctaText }}</span>
            </a>
          </div>
        </tlc-churn-flow-solution-card>
      </div>
    </tlc-churn-flow-reason-template>
  </div>

  <div class="right">
    <tlc-churn-flow-insights />
  </div>
</tlc-churn-flow-step-template>
